import React, {useEffect, useState, useMemo} from 'react'
import qq from 'fine-uploader'
import {useLazyConstant, useRefState} from '@startlibs/core'
import {getFileNameAndExtension} from '../utils/AttachmentsUtils'

const HANGOUT_TIMEOUT = 3*60e3

export const useUploader = (fileToUpload, {params, onSuccess, onCancel, onFailure, jwt}) => {
  const [progress, setProgress] = useState(0)
  const firstProgress = useRefState(true)

  const manualUploader = useMemo(() => {
    if (!fileToUpload)
      return

    let hangoutFailure = -1
    const [filename,extension] = getFileNameAndExtension(fileToUpload)
    return new qq.FineUploaderBasic({

      autoUpload: true,
      maxConnections: 3,
      // debug: true,
      request: {
        endpoint: '/uploader/uploads',
        filenameParam:'originalFilename',
        params: {
          ...params,
          qqfilename: filename + (extension ? "." : "") + extension,
        },
        customHeaders: {
          "Authorization": `Bearer ${jwt}`
        }
      },
      retry: {
        enableAuto: false,
        maxAutoAttempts: 3
      },

      chunking: {
        enabled: true,
        concurrent: {
          enabled: true
        },
        success: {
          endpoint: '/uploader/chunksdone',
          customHeaders: {
            "Authorization": `Bearer ${jwt}`
          }
        },
        partSize: 5e5
      },

      callbacks: {
        onAllComplete: (success, failed) => {
          if (failed.length) {
            clearTimeout(hangoutFailure)
            setProgress(0)
          }
        },

        onProgress: (id, name, uploaded, total) => {
          clearTimeout(hangoutFailure)
          hangoutFailure = setTimeout(() => {
            manualUploader.cancelAll()
            onFailure(true)
          },HANGOUT_TIMEOUT)
          if (firstProgress.get()) {
            firstProgress.set(false)
          } else {
            setProgress(uploaded / total)
          }
        },
        onComplete: (id, fileName, responseJSON) => {
          clearTimeout(hangoutFailure)
          if (!responseJSON.success) {
            onFailure(responseJSON.error?.indexOf("Invalid filename")>=0 ? 'filename' : true)
          } else {
            setProgress(1)
            onSuccess(responseJSON)
            return true
          }
        }
      }

    })
  }, [fileToUpload])

  useEffect(() => {
    if (manualUploader && fileToUpload) {
      // manualUploader.addFiles([{blob:new Blob([byteArray]),name:this.uploadingMedicalRecordFile.sourceFile.name}],uploadParameters);
      manualUploader.addFiles([fileToUpload])
    }
  }, [fileToUpload])


  const cancel = fileToUpload
    ? (() => {
      manualUploader.cancelAll()
      onCancel()
    })
    : onCancel


  return [progress, cancel]

}